export default __webpack_public_path__ + "static/portal/img/big-stub.d0ed009.png";